/**
 * Oath Splash Screen Service
 * Checks for active splash screens that block login
 */

const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Check if an active splash screen is blocking login.
 * This endpoint does NOT require authentication.
 * @param {string} type - "p" for Portal, "b" for BSMS
 */
export const checkSplashScreen = async (type = 'p') => {
  try {
    const response = await fetch(`${BASE_URL}oath/splash/check?type=${type}`);
    if (!response.ok) throw new Error('Failed to check splash screen');
    const data = await response.json().catch(() => ({}));
    return {
      success: true,
      active: data.active || false,
      splashScreen: data.splashScreen || null,
    };
  } catch (error) {
    console.error('Error checking splash screen:', error);
    return { success: true, active: false, splashScreen: null };
  }
};
